import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';

export function CloseablePill(props) {
  const { children, onClose, variant, size, className, tooltip } = props;
  const [isVisible, setIsVisible] = useState(true);
  const [isTruncated, setIsTruncated] = useState(false);
  const contentRef = useRef(null);

  const resolvedTooltip =
    tooltip ?? (typeof children === 'string' ? children : undefined);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkTruncation = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkTruncation();

    const observer = new ResizeObserver(checkTruncation);
    observer.observe(el);

    return () => observer.disconnect();
  }, [children, tooltip]);

  const handleClose = () => {
    setTimeout(() => {
      if (onClose) onClose();
    }, 150);
  };

  const titleAttr =
    isTruncated && resolvedTooltip ? resolvedTooltip : undefined;

  return (
    <span className={`pill pill--${variant} pill--${size} ${className}`}>
      <span ref={contentRef} className="pillContent" title={titleAttr}>
        {children}
      </span>
      <button
        onClick={handleClose}
        className="pillClose"
        aria-label="Remove"
      >
        <span className="pillCloseIcon">×</span>
      </button>
    </span>
  );
}
